<template>
  <transition name="modal-bounce">
    <div v-if="show" class="glass-overlay" @click.self="handleOutsideClick">
      <div :class="['glass-modal', `size-${size}`]">

        <!-- درخشش پشت مدال برای جذابیت بیشتر -->
        <div class="glow-effect" :style="{ backgroundColor: accentColor }"></div>

        <!-- Header -->
        <div class="glass-header">
          <div class="header-content">
            <i v-if="title" :class="[icon, 'header-icon']" :style="{ color: accentColor }"></i>
            <h5 class="glass-title">{{ title }}</h5>
          </div>
          <button class="glass-close" @click="$emit('Close')">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>

        <!-- Body -->
        <div class="glass-body custom-scrollbar">
          <slot>
            <h5 class="fw-bold"> خطایی رخ داده ، لطفا به پشتیبانی اطلاع دهید </h5>
          </slot>
        </div>

        <!-- Footer -->
        <div v-if="isFooter" class="glass-footer">
          <slot name="footer">
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
    isFooter: {type:Boolean,default:false},
    title: { type: String, default: '' },
    accentColor: { type: String, default: 'var(--card-lable-dashbord)' },
    size: { type: String, default: 'md' }, // sm, md, lg, xl
    icon: String, // مثلا 'fas fa-shield-alt'
    persistent: {type:Boolean,default:true} // اگر true باشد با کلیک بیرون بسته نمی‌شود
  },
  mounted() {
    document.addEventListener('keydown', this.handleEsc);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleEsc);
  },
  methods: {
    close() { this.$emit('update:show', false); },
    handleOutsideClick() { if (!this.persistent) this.close(); },
    handleEsc(e) { if (e.key === 'Escape' && this.show) this.close(); }
  }
};
</script>

<style scoped>
.glass-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex; justify-content: center; align-items: center;
  z-index: 1059;
}

.glass-modal {
  position: relative;
  background: var(--modal-glasses);
  border: 1px solid var(--modal-border-glasses);
  backdrop-filter: blur(20px);
  border-radius: 17px;
  box-shadow: 0 25px 50px -12px var(--modal-glasses);
  overflow: hidden;
  animation: modal-appear 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.glow-effect {
  position: absolute;
  top: -50px; left: -50px; width: 100px; height: 100px;
  filter: blur(80px); opacity: 0.4; pointer-events: none;
}


.size-sm { width: 350px; }
.size-md { width: 550px; }
.size-lg { width: 850px; }
.size-xl { width: 95%; max-width: 1200px; }


.glass-header {
  padding: 20px 25px;
  display: flex; justify-content: space-between; align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid var(--modal-border-glasses);
}
.header-content { display: flex; align-items: center; gap: 12px; }
.header-icon { font-size: 1.5rem; filter: drop-shadow(0 0 8px currentColor); }
.glass-title { margin: 0; letter-spacing: 0.5px; }

.glass-close {
  background: var(--modal-border-glasses); 
  border: none;
  width: 32px; height: 32px; border-radius: 50%;
  color: white; cursor: pointer; transition: 0.3s;
}
.glass-close:hover { background: rgba(255, 0, 0, 0.4); transform: rotate(90deg); }


.glass-body { padding: 30px 25px; max-height: 70vh; overflow-y: auto; }


.glass-footer {
  padding: 15px 25px;
  display: flex; justify-content: flex-end; gap: 15px;
  background: rgba(255, 255, 255, 0.05);
}
.btn-glass {
  padding: 10px 24px; border-radius: 12px; border: none;
  cursor: pointer; font-weight: 600; transition: 0.3s;
  display: flex; align-items: center; gap: 8px;
}
.btn-glass.primary { color: white; box-shadow: 0 4px 15px rgba(0,0,0,0.2); }
.btn-glass.primary:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,0,0,0.3); }
.btn-glass.secondary { background: rgba(255, 255, 255, 0.1); color: white; }
.btn-glass.secondary:hover { background: rgba(255, 255, 255, 0.2); }


.spinner {
  width: 18px; height: 18px; border: 2px solid rgba(255,255,255,0.3);
  border-top-color: white; border-radius: 50%; animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }


@keyframes modal-appear {
  from { opacity: 0; transform: scale(0.9) translateY(30px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}


.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 10px; }
</style>